import city from 'app/entities/city/city.reducer';
import pincode from 'app/entities/pincode/pincode.reducer';
import category from 'app/entities/category/category.reducer';
import subCategory from 'app/entities/sub-category/sub-category.reducer';
import product from 'app/entities/product/product.reducer';
import userDetails from 'app/entities/user-details/user-details.reducer';
import promocode from 'app/entities/promocode/promocode.reducer';
import charges from 'app/entities/charges/charges.reducer';
import order from 'app/entities/order/order.reducer';
import orderProduct from 'app/entities/order-product/order-product.reducer';
import orderProducts from 'app/entities/order-products/order-products.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  city,
  pincode,
  category,
  subCategory,
  product,
  userDetails,
  promocode,
  charges,
  order,
  orderProduct,
  orderProducts,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
